import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["dangerouslySetInnerHTML"];
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
const ScriptTag = _ref => {
  let {
      dangerouslySetInnerHTML: innerHtml
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const wrapperRef = useRef(null);
  useEffect(() => {
    const script = document.createElement('script');
    Object.entries(otherProps).forEach(([key, value]) => {
      if (key === 'children') return;
      script[key] = value;
    });
    if (!script.type) script.type = 'text/javascript';
    if (innerHtml) script.text = innerHtml.__html;
    wrapperRef.current.appendChild(script);
  });
  return /*#__PURE__*/React.createElement("span", {
    ref: wrapperRef
  });
};
ScriptTag.propTypes = {
  dangerouslySetInnerHTML: PropTypes.object
};
ScriptTag.defaultProps = {
  dangerouslySetInnerHTML: null
};
export default ScriptTag;
//# sourceMappingURL=ScriptTag.js.map